













import { Component, Prop, Vue } from 'vue-property-decorator';
import { IUser, PolicyFilter } from 'admiral-core';
import { PreferencesAction } from '@/store/PreferencesModule';
import Avatar from '@/components/common/Avatar.vue';

@Component({
  components: { Avatar },
})
export default class PolicyUserLink extends Vue {
  @Prop({ type: Object })
  user!: IUser;

  @Prop({ type: Boolean, default: () => true })
  isActive!: boolean;

  get filter(): PolicyFilter {
    return this.$store.state.PreferencesModule.policyFilter;
  }

  async handleClick(event: MouseEvent) {
    if (!this.isActive) {
      return false;
    }
    const filter = (await this.$store.getters['PreferencesModule/getPolicyFilter']) as PolicyFilter;
    if ((filter.users || []).find((user: IUser) => user.id === this.user.id)) {
      filter.users = [];
    } else {
      filter.users = [this.user];
    }
    await this.$store.dispatch(`PreferencesModule/${PreferencesAction.setPolicyFilter}`, filter);
  }

  title() {
    if ((this.filter.users || []).find((user: IUser) => user.id === this.user.id)) {
      return 'Filter entfernen';
    } else {
      return `Filter setzen`;
    }
  }
}
